import React, { Component } from "react";
import { Loading } from "../../../../common/loading";
import Comment from "../../../../common/comments/comment.component";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inventoryEquipmentActions } from "../../../../../store/external/inventory/equipment.reducer";
import { MAX_LENGTH } from "../../../../../../app/constants/external-constants";

class EquipmentComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
        }

    }
    componentDidMount() {
        const { getInventoryEquipmentComments, inventoryEquipment } = this.props;
        getInventoryEquipmentComments(this.props.equipmentId, inventoryEquipment?.commentsPage)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }


    async postComment(attachedFilename, attachedFileData, commentDescription) {
        const { postInventoryEquipmentComments } = this.props;
        await postInventoryEquipmentComments(this.props.equipmentId, attachedFilename, attachedFileData, commentDescription).then(() => {
            this.setState({ isLoading: false })
        });
    }


    handleDeleteEquipmentComments = async (equipmentId) => {
        this.setState({ isLoading: true });
        const { deleteInventoryEquipmentComments, getInventoryEquipmentComments, inventoryEquipment, resetEquipmentComments } = this.props;
        await deleteInventoryEquipmentComments(equipmentId, this.props.equipmentId);
        await resetEquipmentComments();
        await getInventoryEquipmentComments(this.props.equipmentId, 1, inventoryEquipment?.inventoryEquipmentComments?.length).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

    handleLoadMore = async () => {
        const { getInventoryEquipmentComments, inventoryEquipment, equipmentId } = this.props;
        await getInventoryEquipmentComments(equipmentId, inventoryEquipment.commentsPage + 1)
    }

    componentWillUnmount() {
        const { resetEquipmentComments } = this.props;
        resetEquipmentComments();
    }

    render() {
        if (this.state.isLoading) {
            return <Loading />
        }
        const { inventoryEquipmentComments } = this.props.inventoryEquipment
        return (

            <Comment
                commentList={inventoryEquipmentComments}
                addCommentAction={this.postComment.bind(this)}
                deleteCommentAction={this.handleDeleteEquipmentComments.bind(this)}
                maxLength={MAX_LENGTH.limit_500}
                isEquipment={true}
                handleLoadMore={this.handleLoadMore}
                hasMoreComments={this.props?.inventoryEquipment?.hasMoreComments}             
                //Access Type
                isReadOnly={this.props.isReadOnly}
                isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                isReadAndWrite={this.props.isReadAndWrite}
            />
        )
    }
}
export default connect(
    state => {
        const { inventoryEquipment } = state;
        const { inventoryEquipmentFormA } = state.form;

        return {
            inventoryEquipment,
            inventoryEquipmentFormA
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryEquipmentActions),
        dispatch
    )
)(EquipmentComment);